// extracted by mini-css-extract-plugin
export default {"Label":"Label-module__Label__foT2sd7","Icon":"Label-module__Icon__KWDKdc7"};